<template>
  <section class="prices-index">
    <commercial-list
      :items="items"
      :actions="actions"
      :rules="vehiclePrices"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import monetize from '@sdk/helpers/formatters/monetize';

  import CommercialListButton from '@/views/Settings/Commercial/List/Button.vue';
  import CommercialList from '@/views/Settings/Commercial/List.vue';

  export default {
    name: 'PricesIndex',
    components: {
      CommercialList,
    },
    data() {
      return {
        nav: {
          action: CommercialListButton,
        },
        items: [{
          id: 'minPrice',
          label: 'Preço mínimo',
          field: 'min_price_cents',
          formatter: monetize,
        }, {
          id: 'defaultPrice',
          label: 'Preço padrão',
          field: 'default_price_cents',
          formatter: monetize,
        }],
        actions: {
          update: 'settings-commercial-prices-update',
          delete: 'vehiclePrices/delete',
        },
      };
    },
    computed: {
      ...mapState([
        'vehiclePrices',
      ]),
    },
    mounted() {
      this.getVehiclePrices();
    },
    methods: {
      getVehiclePrices() {
        this.$store
          .dispatch('vehiclePrices/list', { per_page: 99999 });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
